<template>
    <b-container fluid class="py-3 disposal_screen">
        <b-row>
            <b-col>
                <SkeletonTableLoader :columns="headers" :loading="loading" />
                <div v-if="!loading">
                    <Tableview :value="items" :paginator="false" class="p-datatable-gridlines" :rows="10"
                        :rowHover="true" filterDisplay="menu" :loading="loading" responsiveLayout="scroll"
                        :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters"
                        selectionMode="single" dataKey="RowNumber" :totalRecords="rowsCount" :state="state"
                        @ShowRows="ShowRows">
                        <template v-slot:Status="{ data }">
                            <GreenStatus name="Completed" v-if="data.Status == '3'" />
                        </template>
                    </Tableview>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted, reactive, watch } from 'vue';
import Tableview from "../../../../../../../components/FormComponents/Table.vue";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import DisposalService from '../../../../../../../modules/Inventory/Service/AssetManagement/DisposalService';
import SkeletonTableLoader from "../../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import { useI18n } from 'vue-i18n';
import { useRouter, useRoute } from "vue-router";
export default defineComponent({
    components: {
        Tableview,
        SkeletonTableLoader
    },
    props: {
        activeIndex: {
            type: Number,
            default: 0,
        },
    },
    setup(props, { emit }) {
        const items = ref([]);
        const loading = ref(false);
        const rowFocus = ref(false);
        const datefilter = ref({
            fromdate: '01/01/1800',
            todate: '01/01/9999'
        })
        const { t } = useI18n();
        const rowsCount = ref(0);
        const asset_details = ref()
        const activeTabIndex = ref(props.activeIndex);
        const state = reactive({
            pagedItems: [], // contains a subset of rows for the current page
            currentPage: 1, // current page number
            pageSize: 10, // number of rows per page
            totalRows: 0, // total number of rows in the database
        });
        const routes = useRoute();
        let SessionUserData = localStorage.getItem("UsersData");
        let usersData;
        if (SessionUserData !== null) {
            usersData = JSON.parse(SessionUserData);
        }

        let SessionRolesData = localStorage.getItem("RolesData");
        let rolesData;
        if (SessionRolesData !== null) {
            rolesData = JSON.parse(SessionRolesData);
        }

        let SessionEntityData = localStorage.getItem("EntityData");
        let EntityData;
        if (SessionEntityData !== null) {
            EntityData = JSON.parse(SessionEntityData);
        }
        let HospitalId = Number(usersData.OrganizationId);
        const ParamValues = ref({
            StoreId: Number(routes.query.Id ?? 0),
            BranchId: Number(routes.query.BranchId ?? 0),
        });
        watch(
            () => props.activeIndex,
            (newVal: any) => {
                IsShow()
            },
            { deep: true }
        );
        function ShowRows(value) {
            debugger;
            if (value != 0 && value != null && value != undefined) {
                state.pageSize = value;
                IsShow();
            }
        }
        const headers = [
            {
                header: t('assetManagement.Disposal.SNo'),
                field: "RowNumber",
            },
            {
                header: t('assetManagement.Disposal.Asset Name'),
                field: "AssetName",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
            {
                header: t('assetManagement.Disposal.Barcode'),
                field: "BarCode",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
            {
                header: t('assetManagement.Disposal.Category'),
                field: "Category",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
            {
                header: t('assetManagement.Disposal.CurrentStatus'),
                field: "CurrectStatus",
                slot: "Status",
                fieldDisplay: "false",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
            {
                header: t('assetManagement.Disposal.Location'),
                field: "Location",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
            {
                header: t('assetManagement.Disposal.Assigned To'),
                field: "AssignName",
                filterTemplate: "MultiSelect",
                ShowMactchMode: false,
            },
        ]
        const filters = {
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            AssetName: { value: null, matchMode: FilterMatchMode.CONTAINS, options: items },
            Barcode: { value: null, matchMode: FilterMatchMode.CONTAINS, options: items },
            Category: { value: null, matchMode: FilterMatchMode.CONTAINS, options: items },
            Status: { value: null, matchMode: FilterMatchMode.CONTAINS, options: items },
            Location: { value: null, matchMode: FilterMatchMode.CONTAINS, options: items },
            AssignedTo: { value: null, matchMode: FilterMatchMode.CONTAINS, options: items },
        };

        const filteredColumns = computed(() => {
            return headers.filter((col) => col.field !== "id");
        });

        const globalFilterFields = ref(headers.map((col) => col.field));
        const IsShow = async () => {
            try {
                loading.value = true;
                const pageNum = state.currentPage;
                //  const pageSize = state.pageSize;
                let count = 0;
                const pageSize = 1;
                const response = await DisposalService.getdata(
                    ParamValues.value.StoreId, ParamValues.value.BranchId, HospitalId,
                    datefilter.value.fromdate,
                    datefilter.value.todate,
                    pageNum,
                    pageSize);
                console.log('getdata', response);
                items.value = response["result"].completedList.map((item: any) => {
                    count = count + 1;
                    item.RowNumber = count;
                    return item;
                });
                rowsCount.value =
                    response["result"].completedList.length > 0
                        ? response["result"].completedList["rowscount"]
                        : 0;
                console.log('items_list', items.value);
                loading.value = false;
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        onMounted(() => {
            IsShow();
        });

        return {
            items,
            loading,
            headers,
            filters,
            filteredColumns,
            globalFilterFields,
            rowsCount,
            state,
            ShowRows,
            rowFocus,
            asset_details,
            t,
            activeTabIndex,
            ParamValues
        }
    }
})
</script>
<style lang="scss" scoped>
.disposal_text {
    cursor: pointer;
    color: #0A82FF;
    text-decoration: underline;
}
</style>
